var exports = {
  "Wl": "EmbedGifv.module__imagePreviewHandler___ckhiNl",
  "tN": "EmbedGifv.module__blurContainer___ckhiNl",
  "rj": "EmbedGifv.module__blurContent___ckhiNl",
  "JV": "EmbedGifv.module__blurInnerContainer___ckhiNl",
  "aO": "EmbedGifv.module__thumbHashPlaceholder___ckhiNl",
  "il": "EmbedGifv.module__mediaContainer___ckhiNl",
  "M_": "EmbedGifv.module__videoWrapper___ckhiNl",
  "UD": "EmbedGifv.module__videoElement___ckhiNl",
  "qf": "EmbedGifv.module__placeholder___ckhiNl",
  "ci": "EmbedGifv.module__placeholderFastFade___ckhiNl",
  "Ap": "EmbedGifv.module__placeholderVisible___ckhiNl",
  "uR": "EmbedGifv.module__placeholderHidden___ckhiNl",
};

module.exports = exports;
